import { AbstractControl, FormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. Example:
 * { data: { construction_elements: ["fieldName1", "fieldName2"], sum: "100"}}
 * @returns true if validation passed. An object with the validation id and a message property inside if failed. Example: { "date": { message: "Something went wrong"}}
 */

export function sumTotalValidator(
  control: AbstractControl,
  form: FormlyFieldConfig,
  options: any = {}
) {
  const model = control.value;
  if (!model) {
    return null;
  } 
  let path = '';
  let flag: boolean = false;
  let message: string = '';  
  if(model< 0){
    flag = true;
    message = '"a" must be equal to or greater than "b1+b2"';
    path = options.data.errorPath;
  }else {
    flag = false;
  }
  //Convert object to record if an array of items to be calculated in future 
  // const data: Record<string, string> = options.data.keysToCalculate; 
  // const mod = Object.entries(data);
  // mod.forEach(([key, value]) => {           
  //   if(model[value] < 0){
  //     flag = true;
  //     message = '"a" must be equal to or greater than "b1+b2"';
  //     path = options.data.errorPath;
  //   }else {
  //     flag = false;
  //   }
  // }); 

  return flag
    ? {
      sumTotalValidation : {
          message: options.data.message || message          
        },
      }
    : null;
}
